import "core-js/modules/es.array.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import repository from "../actions";
import { browserDraftsStorageStringifier, isObject, serializeObject } from "@/assets/js/mcn-helpers";
import User from "../../assets/js/models/user/User";
import JsonMappedUser from "../../assets/js/models/user/User";
import JsonMappedRole from "../../assets/js/models/role/Role";
import Role from "../../assets/js/models/role/Role";
import Form from "../../assets/js/Form";
import AuthData from "../../assets/js/models/user/AuthData";
import VuetifyTable from "../../assets/js/VuetifyTable";
import Pixel from "@/assets/js/models/pixel/Pixel";
import UserWhatsappSettings from "@/assets/js/models/user/UserWhatsappSettings";
const state = {
  sideBarMenuState: true,
  pageLoading: false,
  savedData: {
    token: null,
    authUser: null,
    whatsAppData: null,
    last_registration_referrer_id: null,
    learningHints: {
      importDialog: {
        comments: {
          validation: true
        }
      }
    },
    tables: {}
  },
  data: {
    logged: false,
    notifications: true,
    user: null,
    userPixels: {}
  },
  globalFilter: {
    domainId: null
  },
  drafts: {},
  language: {
    language: 'en',
    rtl: false
  }
};
const mutations = {
  SET_LAST_REGISTRATION_REFERRER_ID(state, id) {
    state.savedData.last_registration_referrer_id = id;
  },
  SET_GLOBAL_DOMAIN_ID(state, id) {
    state.globalFilter.domainId = id;
  },
  UPDATE_TABLE_COLUMNS(state, {
    name,
    columns
  }) {
    if (!state.savedData.tables.hasOwnProperty(name)) {
      state.savedData.tables[name] = {
        columns
      };
      return;
    }
    state.savedData.tables[name].columns = columns;
  },
  SET_DRAFTS(state, payload) {
    var _payload$selected_id;
    let formInstance = payload.formObject;
    if (!(formInstance instanceof Form)) return;
    let className = payload.name;
    payload.selected_id = (_payload$selected_id = payload.selected_id) !== null && _payload$selected_id !== void 0 ? _payload$selected_id : 'default';
    if (!isObject(state.drafts)) state.drafts = {};
    if (!isObject(state.drafts[className])) state.drafts[className] = {};
    //state.drafts[className][payload.selected_id] = JSON.parse(JSON.stringify(formInstance, browserStorageStringifier))
    const parsedInstance = JSON.parse(JSON.stringify(formInstance, browserDraftsStorageStringifier));
    state.drafts[className][payload.selected_id] = parsedInstance;
  },
  DELETE_DRAFT(state, payload) {
    var _state$drafts, _payload$id;
    let formName = payload.name;
    if ((_state$drafts = state.drafts) !== null && _state$drafts !== void 0 && (_state$drafts = _state$drafts[formName]) !== null && _state$drafts !== void 0 && _state$drafts[(_payload$id = payload.id) !== null && _payload$id !== void 0 ? _payload$id : 'default']) {
      var _payload$id2;
      delete state.drafts[formName][(_payload$id2 = payload.id) !== null && _payload$id2 !== void 0 ? _payload$id2 : 'default'];
    }
  },
  SET_LANGUAGE(state, payload) {
    state.language = payload;
  },
  ACTIVATE_NOTIFICATIONS(state, payload) {
    state.data.notifications = payload;
  },
  SET_PIXEL(state, payload) {
    state.data.userPixels[payload.id] = payload.data;
  },
  DEL_PIXEL(state, payload) {
    delete state.data.userPixels[payload.id];
  },
  SET_TOKEN(state, token) {
    state.savedData.token = token;
  },
  SET_WHATSAPP_DATA(state, whatsappData) {
    state.savedData.whatsAppData = whatsappData;
  },
  SET_LOGGED(state, payload) {
    state.data.logged = payload.state;
  },
  SET_USER(state, user) {
    state.data.user = user;
    state.savedData.authUser = user;
  },
  DONT_SHOW_IMPORT_VALIDATION_COMMENT(state) {
    state.savedData.learningHints.importDialog.comments.validation = false;
  }
};
const actions = {
  setGlobalDomainId({
    commit
  }, id) {
    commit('SET_GLOBAL_DOMAIN_ID', id);
  },
  updateTableColumns({
    commit
  }, table) {
    if (!(table instanceof VuetifyTable)) return;
    let columns = table.getHeaders().reduce((columns, header, i) => {
      if (!columns.hasOwnProperty(header.value)) {
        columns[header.value] = {
          visibility: header.visibility,
          position: i
        };
        return columns;
      }
      columns[header.value].visibility = header.visibility;
      columns[header.value].position = i;
      return columns;
    }, {});
    commit('UPDATE_TABLE_COLUMNS', {
      name: table.getName(),
      columns
    });
  },
  dontShowImportValidationComment({
    commit
  }) {
    commit('DONT_SHOW_IMPORT_VALIDATION_COMMENT');
  },
  setLastRegistrationReferrerId({
    commit
  }, id) {
    commit('SET_LAST_REGISTRATION_REFERRER_ID', id);
  },
  draftObject({
    commit
  }, payload) {
    commit('SET_DRAFTS', payload);
  },
  deleteDraftObject({
    commit
  }, payload) {
    commit('DELETE_DRAFT', payload);
  },
  setLanguage({
    commit
  }, payload) {
    commit('SET_LANGUAGE', payload);
  },
  setToken({
    commit
  }, payload) {
    commit('SET_TOKEN', payload);
  },
  removeToken({
    commit
  }) {
    commit('SET_TOKEN', null);
  },
  initOrder({
    commit
  }, payload) {
    commit('DELETE_ORDER', {
      salePageName: payload.salePageName
    });
  },
  activateNotifications({
    commit
  }, payload) {
    commit('ACTIVATE_NOTIFICATIONS', payload);
  },
  setPixels({
    commit
  }, payload) {
    commit('SET_PIXEL', payload);
  },
  deletePixels({
    commit
  }, payload) {
    commit('DEL_PIXEL', payload);
  },
  setWhatsAppData({
    commit
  }, payload) {
    const whatsappData = payload instanceof AuthData ? payload.getWhatsAppData() : null;
    commit('SET_WHATSAPP_DATA', whatsappData);
  },
  setUser({
    commit
  }, payload = null) {
    let user = payload instanceof AuthData ? payload.getUser() : payload;
    commit('SET_USER', user);
  },
  removeUser({
    commit
  }) {
    commit('SET_USER', null);
  },
  setAuthData({
    commit
  }, authData) {
    if (!(authData instanceof AuthData)) {
      return;
    }
    commit('SET_WHATSAPP_DATA', authData.getWhatsAppData());
    commit('SET_USER', authData.getUser());
    const token = authData.getAccessToken();
    if (token) {
      commit('SET_TOKEN', token);
    }
  },
  removeUserData({
    commit
  }) {
    commit('SET_USER', null);
    commit('SET_TOKEN', null);
  },
  SendRequest({
    commit,
    state
  }, payload = {}) {
    if (!payload.test) payload.headers = {
      'Authorization': `Bearer ${state.savedData.token}`
    };
    return repository.sendApiRequest({
      commit,
      state,
      ...payload
    });
  },
  SendFormRequest({
    commit,
    state
  }, payload = null) {
    if (!payload.test) payload.headers = {
      'Authorization': `Bearer ${state.savedData.token}`
    };
    payload.contentType = 'form-data';
    return repository.sendApiRequest({
      commit,
      state,
      ...payload
    });
  }
};
const getters = {
  globalDomainId: state => state.globalFilter.domainId,
  getToken: state => state.savedData.token,
  getLastRegistrationId: state => state.savedData.last_registration_referrer_id,
  getAuthUser: state => new JsonMappedUser(state.savedData.authUser),
  authenticatedUser: state => new JsonMappedUser(state.savedData.authUser),
  authenticatedUserNextSubscriptionPlan: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getNextSubscriptionPlan() : null,
  authenticatedUserSubscriptionPlan: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getSubscriptionPlan() : null,
  authenticatedUserRole: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getRole() : null,
  authenticatedUserInBasicPlan: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser && getters.authenticatedUser.inBasicPlan(),
  authenticatedUserRoleName: (state, getters) => getters.authenticatedUserRole instanceof JsonMappedRole ? getters.authenticatedUser.getRoleName() : null,
  authenticatedUserPostbackUrl: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getPostBackUrl() : null,
  authenticatedUserOriginalPixels: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getPixels() : [],
  authenticatedUserPermissions: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getJsonPermissions() : [],
  authenticatedUserPlanPermissions: (state, getters) => getters.authenticatedUser instanceof JsonMappedUser ? getters.authenticatedUser.getPlanPermissions() : [],
  authenticatedUserHasPlanPermission: (state, getters) => permission => getters.authenticatedUser instanceof JsonMappedUser && getters.authenticatedUser.hasPlanPermission(permission),
  authenticatedUserHasPermission: (state, getters) => permission => getters.authenticatedUser instanceof JsonMappedUser && getters.authenticatedUser.isPermitted(permission),
  isPermitted: (state, getters) => permission => getters.getAuthUser instanceof User && getters.getAuthUser.isPermitted(permission),
  isRolePermitted: (state, getters) => role => getters.getAuthUser instanceof User && getters.getAuthUser.isRolePermitted(role),
  isUserEmailVerified: (state, getters) => getters.getAuthUser instanceof User && getters.getAuthUser.isEmailVerified(),
  getAuthUserId: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getId() : null,
  getAuthUserPermissions: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getPermissions() : [],
  getActivityPoints: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getActivityPoints() : 0,
  getTutorials: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getTutorials() : [],
  isAuthUserPermitted: (state, getters) => permission => getters.getAuthUser instanceof User ? getters.getAuthUser.isPermitted(permission) : false,
  getAuthUserRole: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getUserRole() : null,
  getAuthUserName: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getUserName() : null,
  getAuthUserRoleName: (state, getters) => getters.getAuthUserRole instanceof Role ? getters.getAuthUserRole.getRoleName() : null,
  getAuthUserManager: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getManager() : null,
  isAdmin: (state, getters) => getters.getAuthUserRoleName === Role.ADMIN_ROLE || getters.authenticatedUserRoleName === Role.ADMIN_ROLE,
  isManager: (state, getters) => getters.getAuthUserRoleName === Role.MANAGER_ROLE || getters.authenticatedUserRoleName === Role.MANAGER_ROLE,
  isWarehouse: (state, getters) => getters.getAuthUserRoleName === Role.WAREHOUSE_ROLE || getters.authenticatedUserRoleName === Role.WAREHOUSE_ROLE,
  isSeller: (state, getters) => getters.getAuthUserRoleName === Role.SELLER_ROLE || getters.authenticatedUserRoleName === Role.SELLER_ROLE,
  isInfluencer: (state, getters) => getters.getAuthUserRoleName === Role.INFLUENCER_ROLE || getters.authenticatedUserRoleName === Role.INFLUENCER_ROLE,
  isStandard: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.isStandard() : false,
  getAuthPixels: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getPixels() : [],
  getAuthPostbackUrl: (state, getters) => getters.getAuthUser instanceof User ? getters.getAuthUser.getPostBackUrl() : null,
  whatsappData: (state, getters) => new UserWhatsappSettings(state.savedData.whatsAppData),
  getPixel: state => id => {
    let pixels = state.data.userPixels[id];
    return Array.isArray(pixels) ? pixels.map(pixel => new Pixel(pixel)) : [];
  },
  userWarehouseId: (state, getters) => getters.getUser instanceof User ? getters.getUser.getUserWarehouseId() : null,
  getUser: state => serializeObject(state.data.user, User),
  getSideBarMenuState(state) {
    return state.sideBarMenuState;
  },
  getPixels(state) {
    return state.data.userPixels;
  },
  getPageLoading(state) {
    return state.pageLoading;
  },
  getAuthToken(state) {
    return state.savedData.token;
  },
  isNotificationsActive(state) {
    return state.data.notifications;
  },
  getLanguage(state) {
    return state.language;
  },
  getDraftedObject: state => (Class, id) => {
    var _state$drafts$Class$n, _state$drafts$Class$n2;
    if (!Form.isPrototypeOf(Class)) return null;
    return (_state$drafts$Class$n = (_state$drafts$Class$n2 = state.drafts[Class.name]) === null || _state$drafts$Class$n2 === void 0 ? void 0 : _state$drafts$Class$n2[id !== null && id !== void 0 ? id : 'default']) !== null && _state$drafts$Class$n !== void 0 ? _state$drafts$Class$n : null;
  },
  canShowImportValidationComment(state) {
    return state.savedData.learningHints.importDialog.comments.validation;
  },
  getTableColumns: state => table => {
    if (!(table instanceof VuetifyTable)) return;
    let namedTable = state.savedData.tables[table.getName()];
    if (!namedTable) namedTable = {
      columns: {}
    };
    let tableColumns = namedTable.columns;
    table.getHeaders().forEach(header => {
      var _tableColumns$header$;
      let storedHeaderColumn = (_tableColumns$header$ = tableColumns === null || tableColumns === void 0 ? void 0 : tableColumns[header.value]) !== null && _tableColumns$header$ !== void 0 ? _tableColumns$header$ : null;
      if (!storedHeaderColumn) return;
      header.visibility = storedHeaderColumn.visibility;
    });
    table.getHeaders().sort((a, b) => {
      var _tableColumns$a$value, _tableColumns$a$value2, _tableColumns$b$value, _tableColumns$b$value2;
      return ((_tableColumns$a$value = (_tableColumns$a$value2 = tableColumns[a.value]) === null || _tableColumns$a$value2 === void 0 ? void 0 : _tableColumns$a$value2.position) !== null && _tableColumns$a$value !== void 0 ? _tableColumns$a$value : 0) - ((_tableColumns$b$value = (_tableColumns$b$value2 = tableColumns[b.value]) === null || _tableColumns$b$value2 === void 0 ? void 0 : _tableColumns$b$value2.position) !== null && _tableColumns$b$value !== void 0 ? _tableColumns$b$value : 0);
    });
  }
};
export default {
  namespace: true,
  state,
  mutations,
  actions,
  getters
};